// src/Routes.jsx
import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
import NotFound from "pages/NotFound";
import HomepageCinematicGateway from "pages/homepage-cinematic-gateway";
import CinematicShowcasePortfolio from "pages/cinematic-showcase-portfolio";
import StudioUniverseAbout from "pages/studio-universe-about";
import BookingConciergeConsultation from "pages/booking-concierge-premium-consultation";
import CorporateSolutionsServices from "pages/corporate-solutions-services";
import BrandCollaborationsClientStories from "pages/brand-collaborations-client-stories";
import Footer from "components/ui/Footer";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Header />
        <RouterRoutes>
          <Route path="/" element={<HomepageCinematicGateway />} />
          <Route path="/homepage-cinematic-gateway" element={<HomepageCinematicGateway />} />
          <Route path="/cinematic-showcase-portfolio" element={<CinematicShowcasePortfolio />} />
          <Route path="/cinematic-showcase-portfolio/:id" element={<CinematicShowcasePortfolio />} />

          <Route path="/studio-universe-about" element={<StudioUniverseAbout />} />
          <Route path="/booking-concierge-premium-consultation" element={<BookingConciergeConsultation />} />
          <Route path="/corporate-solutions-services" element={<CorporateSolutionsServices />} />
          <Route path="/brand-collaborations-client-stories" element={<BrandCollaborationsClientStories />} />
          <Route path="*" element={<NotFound />} />
          
        </RouterRoutes>
        <Footer />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;